import React from 'react';

const Logo = () => {
  return (
    <div className="text-center mb-8">
      <span className="text-6xl mb-4 block">🍑</span>
      <h1 className="text-4xl font-black text-gray-800">Peach</h1>
    </div>
  );
};

export default Logo;
